export default "__VITE_ASSET__d4a28ff1__"